import { useState, useEffect } from 'react';
import { GetStepCount2, GetRejectSetting, BulkActionReject } from '../../../actions/BulkActions';

const BulkRejectDlg = (props) => {
    const [docCount, setDocCount] = useState(0);
    const [rejectReason, setRejectReason] = useState('');
    const [reasonReq, setReasonReq] = useState(false);
    const [display, setDisplay] = useState('input');
    const [updateResults, setUpdateResults] = useState([]);

    useEffect(() => {
        let search = props.getSearch();
        console.log(search);
        GetRejectSetting(rejectCallback);
        if(search.fullStep) {
          // need to query
          GetStepCount2(search, stepCountCallback);
        } else {
          setDocCount(search.docs.length);
        }
        setDisplay('input');
    }, []);

    const bulkRejectClick = () => {
      let docs = props.docs();
      let search = props.getSearch();
      console.log(docs);
      console.log(search);
      BulkActionReject(search, docs.docIds, rejectReason, finalCallback);
    }

    const rejectCallback = (reqReason) => {
      setReasonReq(reqReason);
    }

    const finalCallback = (results) => {
      console.log(results);
      setUpdateResults(results.responseDocuments);
      setDisplay('done');

    }

    const stepCountCallback = (count) => {
        console.log(count);
        setDocCount(count);

    }

    return (
        <div className='td-dialogue-container'>
            <div
              className='td-dialogue card'
              style={{ height: '600px', width: '600px' }}
            >
              <div className='card-header'>
                Bulk Reject
                <button onClick={() => props.close()} className='btn-close' />
              </div>
              <div className='card-body'>
                {display === 'input' &&
                <>
                <div className='mt-2 ms-3'>
                  <label className='form-check-label'>
                    {docCount === 1 && (
                      <>1 document will be rejected</>
                    )}
                    {docCount > 1 && (
                      <>{docCount} documents will be rejected</>
                    )}
                  </label>
                </div>
                {docCount > 0 &&
                  <>
                  {reasonReq &&
                    <div className='form-group mt-2'>
                      <label>Please provide a reject reason</label>
                      <input className='form-control' value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}></input>
                    </div>
                  }
                    <button
                    onClick={bulkRejectClick}
                    className='btn btn-danger mt-3 w-100'
                    disabled={reasonReq && rejectReason.length === 0 ? true : false}
                    >
                    Reject
                    </button>
                  </>
                }
                </> }
                {display === 'done' &&
                  <div>
                    <div style={{fontSize: '12pt'}} className='mt-4'>{`${updateResults.length} document${updateResults.length > 1 ? 's' : ''} updated.`}</div>
                    <div style={{height: '300px', overflow: 'auto'}}>
                        <ul>
                            {updateResults.map((doc) => (
                                <li key={doc.documentId} >Document {doc.documentId}: {doc.message}</li>
                            ))}
                        </ul>
                    </div>
                    <button className='btn btn-secondary mt-1' onClick={() => props.close('done')}>Close</button>

                  </div>
                }
              </div>

            </div>
          </div>

    )
}

export default BulkRejectDlg;